import { Http } from "../../../../../../helpers/axois";
import *  as _ from 'lodash';
import { isValidFuncName } from "../../../../../marketplace/apps/helpers";
import { pushToast } from "../../../../../../stateManager/store/toast/actions";

export async function getFunctions(appId: string, versionId: string) {
    return new Promise((resolve, reject) => {
        Http.get(`/apps/${appId}/functions?versionId=${versionId}`).subscribe((funcRes: any) => {
            if (funcRes && funcRes.length > 0) {
                let functionsName = ``;
                _.each(funcRes, (c) => {
                    // const code = c.source;
                    // const firstIndex = code.indexOf('function main(');
                    // const lastIndex = code.indexOf(')', firstIndex);

                    // //commenting because of sonarcube issue
                    // if (c.lang === "javascript") {
                    //     // const params = code.substring(firstIndex + 14, lastIndex).split(',').map((d: any) => d + ":any");
                    //     functionsName += `${c.name}(params: Object): Promise<any>\n`
                    // } else {
                    //     // const params = code.substring(firstIndex + 14, lastIndex).split(',').map((d: any) => {
                    //     //     if (d.includes(":")) {
                    //     //         return d;
                    //     //     } else
                    //     //         return d.trim() + ":any";
                    //     // });
                    //     // ${params.join(",")}
                    //     functionsName += `${c.name}(params: Object): Promise<any>\n`
                    // }

                    // invalid function names omitted to studio intelisense
                    if (isValidFuncName(c.name)) {
                        functionsName += `${c.name}(params: Object): Promise<any>\n`
                    }
                })
                if (functionsName.length > 0) {
                    resolve(`
                    interface Ia8func {
                        ${functionsName}
                    };
                    declare var bindParams: any;
                    declare var a8func: Ia8func;
                `)
                }
            } else {
                resolve(`
                declare var a8func: {}
                `)
            }
        }, () => {
            resolve(`
            declare var a8func: {}
            `)
        });
    })
}

export async function autoCompleteI18NData(appId: string, versionId: string, search: any) {
    const language = "ENG"
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            Http.get(`/apps/${appId}/i18n/lang/${language}/search/${search}?versionId=${versionId}`)
                .subscribe(
                    (res: any) => {
                        resolve(res);
                    },
                    (error: any) => {
                        if (error === "Forbidden") {
                            pushToast && pushToast(
                                { type: 'error', message: 'Not Authorized: Please request owner of this organization to provide access' }
                              )
                          }
                        reject(error);
                    }
                );
        }, 600);
    });
}

